import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import get from 'lodash/get'
import LOBOverviewTable from './table'
import LOBOverviewDetail from './detail'

export default class LOBOverview extends React.Component {
  state={ redirect: false, efficiencyData: null }

  clickRow = (data) => {
    this.setState({ redirect: true, efficiencyData: data })
  }

  render() {
    const { redirect, efficiencyData } = this.state
    const efficiencyResources = get(this.props, 'efficiencyResources')
    const efficiencyResource = get(this.props, 'efficiencyResource')
    const exportEfficiencyLOB = get(this.props, 'exportEfficiencyLOB')
    const lobOverview = get(this.props, 'lobOverview')
    const users = get(this.props, 'users')
    const lobs = get(this.props, 'lobs')
    const location = get(this.props, 'location', '')
    const path = get(this.props, 'path', '')

    if (redirect) {
      this.props.getEfficiencyLOB(get(efficiencyData, 'lob_id'), get(efficiencyData, 'month'))
      get(this.props, 'history').push('/efficiency_resource')
      return (<Redirect
        to={ {
          pathname: `/efficiency_resource/lob/${get(efficiencyData, '_id')}`,
          state: { header: 'Efficiency Resource' },
        } }
      />)
    }

    switch (location) {
      case `/efficiency_resource/lob/${path}` : {
        return (
          <LOBOverviewDetail
            efficiencyResource={ efficiencyResource }
            exportEfficiencyLOB={ exportEfficiencyLOB }
          />
        )
      }
      default: {
        return (
          <LOBOverviewTable
            efficiencyResources={ efficiencyResources }
            lobOverview={ lobOverview }
            users={ users }
            lobs={ lobs }
            clickRow={ this.clickRow }
          />
        )
      }
    }
  }
}

LOBOverview.propTypes = {
  getEfficiencyLOB: PropTypes.bool,
}
LOBOverview.defaultProps = {
  getEfficiencyLOB: () => {},
}




// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-overview/index.js